// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2hlnV","savePackageButton":"ClientWallet_savePackageButton__e80Pa"};